import type { AdminScope } from '@/shared/constants/admin-scope'
import { useCallback, useMemo } from 'react'
import { AdminScopeType } from '@/shared/constants/admin-scope'
import { buildScopedAdminPath } from '@/shared/libs/admin-routes'
import { useAdminScope } from './use-admin-scope'

/**
 * Tạo function build path admin theo scope hiện tại của user.
 *
 * @returns Function nhận route module nội bộ (vd `/tenant/:id/surveys`) và trả về URL thật
 * (`/super/...` hoặc `/{tenantSlug}/admin/...`).
 */
export function useScopedAdminPath() {
  const { scopeType, tenantSlug } = useAdminScope()

  const currentScope = useMemo<AdminScope | null>(() => {
    if (scopeType === AdminScopeType.Super) {
      return { type: AdminScopeType.Super }
    }
    if (!tenantSlug) {
      return null
    }
    return { type: AdminScopeType.Tenant, tenantSlug }
  }, [scopeType, tenantSlug])

  return useCallback(
    (route: string) => (currentScope ? buildScopedAdminPath(currentScope, route) : route),
    [currentScope],
  )
}
